import React from "react";
import { Link } from "react-router-dom";

function Footer(props) {
  return (
    <>
      <footer class="dx-footer">
        <div class="dx-box-1">
          <div class="container">
            <div class="row vertical-gap lg-gap">
              <div class="col-sm-6 col-lg-3">
                <div class="dx-widget-footer">
                  <div class="dx-widget-title">
                    <Link to="/index.html" class="dx-widget-logo">
                      <img
                        src="assets/images/logo.svg"
                        alt=""
                        style={{ width: "88px" }}
                      />
                    </Link>
                  </div>
                  <div class="dx-widget-text">
                    <p class="mb-0">
                      &copy; 2019 <span class="dib">All rights reserved.</span>{" "}
                      <span class="dib">Dexad &amp; nK.</span>
                    </p>
                  </div>
                  <div class="dx-widget-text">
                    <ul class="dx-social-links mnt-3">
                      <li>
                        <Link to="/#">
                          <span class="fab fa-behance-square"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <span class="fab fa-instagram"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <span class="fab fa-dribbble"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <span class="fab fa-github"></span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-lg-3">
                <div class="dx-widget-footer">
                  <div class="dx-widget-title"> Useful Links </div>
                  <ul class="dx-widget-list">
                    <li>
                      <Link to="/store.html">Store</Link>
                    </li>
                    <li>
                      <Link to="/checkout.html">Checkout</Link>
                    </li>
                    <li>
                      <Link to="/forums.html">Forums</Link>
                    </li>
                    <li>
                      <Link to="/blog.html">Blog</Link>
                    </li>
                  </ul>
                  <ul class="dx-widget-list">
                    <li>
                      <Link to="/help-center.html">Help Center</Link>
                    </li>
                    <li>
                      <Link
                        data-fancybox
                        data-touch="false"
                        data-close-existing="true"
                        data-src="#signup"
                        to="/javascript:;"
                      >
                        Sign Up
                      </Link>
                    </li>
                    <li>
                      <Link
                        data-fancybox
                        data-touch="false"
                        data-close-existing="true"
                        data-src="#login"
                        to="/javascript:;"
                      >
                        Log In
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-6 col-lg-3">
                <div class="dx-widget-footer">
                  <div class="dx-widget-title"> Latest Products </div>
                  <div class="dx-widget-portfolio">
                    <Link to="/product.html">
                      Quantial – Moving Upon Signs Moveth Lesser
                    </Link>
                    <Link to="/product.html">
                      Sensific – Saying Beast Lesser for in Fruitful
                    </Link>
                    <Link to="/product.html">
                      Minist – Subdue Above for Signs Dry is Have Great
                    </Link>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-lg-3">
                <div class="dx-widget-footer">
                  <div class="dx-widget-title"> Latest Posts </div>
                  <Link to="/single-post.html" class="dx-widget-post">
                    <span class="dx-widget-post-text">
                      <span class="dx-widget-post-title">
                        The Big Thing in Design
                      </span>
                      <span class="dx-widget-post-date">25 Sep 2018</span>
                    </span>
                  </Link>
                  <Link to="/single-post.html" class="dx-widget-post">
                    <span class="dx-widget-post-text">
                      <span class="dx-widget-post-title">
                        Will Coding Ever Rule the World?
                      </span>
                      <span class="dx-widget-post-date">24 Sep 2018</span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
